import { activeRelease, parseCatalogBackup, type Catalog } from './levelCatalog';

/**
 * The published levels the game plays: the active release of the Level Studio catalog,
 * shipped as the `catalog` JSON file of content bundle `levels` (backoffice OTA content).
 * `revision` is the sha256 of the catalog, written by the Level Studio when it publishes.
 */
export type LevelPack = { revision: string; catalog: Catalog };

/** Only the active release: drafts and older history stay in the studio. */
export function releaseCatalog(catalog: Catalog): Catalog {
  const release = activeRelease(catalog);
  return { schema: 1, drafts: {}, releases: release ? [release] : [], activeVersion: release?.version ?? null };
}

/** Validates every board of an untrusted level pack; throws on anything unexpected. */
export function parseLevelPack(value: unknown): LevelPack {
  const data = (typeof value === 'string' ? JSON.parse(value) : value) as Partial<LevelPack> | null;
  if (!data || typeof data.revision !== 'string' || !/^[a-zA-Z0-9-]{1,80}$/.test(data.revision)) throw new Error('Invalid level pack.');
  return { revision: data.revision, catalog: releaseCatalog(parseCatalogBackup(JSON.stringify(data.catalog))) };
}

/** Short label for settings, e.g. "Release 3 · 3e864b8d". */
export function levelPackLabel(pack: LevelPack | undefined): string {
  return pack?.catalog.activeVersion ? `Release ${pack.catalog.activeVersion} · ${pack.revision.slice(0, 8)}` : 'Built-in levels';
}
